import React from 'react';

const HiddenMenuErrorContext = React.createContext();

export const { Provider } = HiddenMenuErrorContext;

export default HiddenMenuErrorContext;
